import mixins from 'vue-typed-mixins';
import I18nMixin from '@/Shared/I18nMixin';

const ClipboardMixin = mixins(I18nMixin).extend({
    methods: {
        async copyToClipboard(text: string) {
            if (await this.copyWithClipboardAPI(text) || this.copyWithExec(text)) {
                this.$bvToast.toast(
                    `"${text}" copied to clipboard`,
                    {
                        title: this.i18nCommon('success').toString(),
                        autoHideDelay: 5000
                    }
                );
            }
            else {
                this.$bvToast.toast(
                    `Could not copy to clipboard. Try selecting the text manually and using Ctrl+C`,
                    {
                        title: this.i18nCommon('error').toString(),
                        autoHideDelay: 5000
                    }
                );
            }
        },
        async copyWithClipboardAPI(text: string): Promise<boolean> {
            let success = false;
            try {
                await navigator.clipboard.writeText(text);

                success = true;
            }
            catch {
                success = false;
            }
            return success;
        },
        copyWithExec(text: string): boolean {
            let success = true;
            const textArea = document.createElement('textarea');
            textArea.value = text;

            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.position = 'fixed';

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                success = document.execCommand('copy');
            }
            catch {
                success = false;
            }
            finally {
                document.body.removeChild(textArea);
            }

            return success;
        },
    },
});

export default ClipboardMixin;
